import React, { useEffect, useState } from "react";
import { Table, Tag, Card, Row, Col, Image, Space } from "antd";
import { MesServices } from "../Services/MesServices";
import dayjs from "dayjs";
import { api_URL } from "../Services/Constantes";
import defaultImage from "./Image/default-image.png"; // Chemin vers l'image par défaut
import defaultImagePart from "./Image/default-image_part.png"; // Chemin vers l'image par défaut
import { TeamOutlined } from "@ant-design/icons";



const Familles = () => {
  const numcont = localStorage.getItem("numcont");
  const nom = localStorage.getItem("nom");
  const prenom = localStorage.getItem("prenom");
  const matricule = localStorage.getItem("matricule");
  const matribenef = localStorage.getItem("matipm");
  const datenaiss = localStorage.getItem("datenaiss");
  //matipm

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); // Pour gérer l'état de chargement
  // const [participant, setParticipant] = useState(null);

  // Instance du service
  const mesServices = new MesServices();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Activer le chargement
      try {
        const benefData = await mesServices.getBenef(numcont); // Appel API avec numcont
        // const participantData = benefData.find(
        //   (item) => item.codebenef === "1"
        // ); // Trouver le participant principal
        const familyData = benefData.filter((item) => item.codebenef !== "1"); // Exclure le participant principal pour la table

        // setParticipant(participantData || null); // Stocker le participant principal
        setData(familyData); // Stocker les autres membres
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      } finally {
        setLoading(false); // Désactiver le chargement
      }
    };

    fetchData();
  }, [numcont]);

  // Colonnes du tableau
  const columns = [
    {
      title: "Photo",
      dataIndex: "matribenef",
      key: "photo",
      align: "center",
      render: (matribenef) => (
        <Image
          // src={`images/photos/${matribenef}.jpg`} // Construire dynamiquement l'URL
          src={`${api_URL}Participant/getPhoto/${matribenef}`}
          alt="Membre"
          width={50}
          height={50}
          style={{
            borderRadius: "50%",
            objectFit: "cover",
            border: "1px solid #fff",
          }}
          onError={(e) => {
            e.target.src = defaultImage;
          }}
        />
      ),
    },
    {
      title: "Matricule",
      dataIndex: "matribenef",
      key: "matribenef",

      sorter: (a, b) => a.matribenef.localeCompare(b.matribenef),
    },
    {
      title: "Type Bénéf.",
      dataIndex: "codebenef",
      key: "codebenef",
      sorter: (a, b) => a.codebenef.localeCompare(b.codebenef),
      filters: [
        ...new Set(
          data
            .map((item) => item?.codebenef) // Récupérer toutes les valeurs `codebenef`
            .filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        ),
      ].map((value) => ({
        text: (() => {
          switch (value) {
            case "1":
              return "Participant";
            case "2":
              return "Epouse";
            case "3":
              return "Enfant";
            case "4":
              return "Epoux";
            case "5":
              return "Ascendant";
            case "6":
              return "Autre";
            default:
              return "Inconnu";
          }
        })(),
        value: value, // Utiliser la valeur brute pour le filtre
      })),
      onFilter: (value, record) => record.codebenef === value,
      render: (codebenef) => {
        switch (codebenef) {
          case "1":
            return "Participant";
          case "2":
            return "Epouse";
          case "3":
            return "Enfant";
          case "4":
            return "Epoux";
          case "5":
            return "Ascendant";
          case "6":
            return "Autre";
          default:
            return "Inconnu"; // Si aucun type ne correspond
        }
      },
    },
    {
      title: "Prénoms",
      dataIndex: "prenoms",
      key: "prenoms",
      sorter: (a, b) => a.prenoms.localeCompare(b.prenoms),
    },
    {
      title: "Nom",
      dataIndex: "nom",
      key: "nom",
      sorter: (a, b) => a.nom.localeCompare(b.nom),
    },
    {
      title: "Adresse",
      dataIndex: "adresse",
      key: "adresse",
      sorter: (a, b) => a.adresse.localeCompare(b.matribenef),
    },
    {
      title: "Age",
      dataIndex: "ageb",
      key: "ageb",
      align: "center",
      sorter: (a, b) => a.ageb.localeCompare(b.ageb),
      render: (age) => <Tag color="#13d61a">{age}</Tag>,
    },
    {
      title: "Sexe",
      dataIndex: "sexe",
      key: "sexe",
      sorter: (a, b) => a.sexe.localeCompare(b.sexe),
    },
    {
      title: "Etat",
      dataIndex: "suspension_benef",
      key: "suspension_benef",
      align: "center",
      render: (suspension_benef) => (
        <Tag color={suspension_benef === "A" ? "#13d61a" : "red"}>
          {suspension_benef}
        </Tag>
      ),
    },
  ];

  // Données des membres de la famille

  return (
    <div
      style={{
        padding: "20px",
        background: "linear-gradient(115deg, #eef2fc 0%, #e4f5ec 38%, #f9eedd 100%)",
        minHeight: "100vh",
        transition: "background 0.7s ease-in-out"
      }}>
      <h2 style={{ marginBottom: "20px", display: "flex", alignItems: "center", gap: 10 }}>
        <TeamOutlined style={{ color: "#1f4ea1", fontSize: 28 }} />
        Ma Famille
      </h2>

      <Card style={{ marginBottom: "20px", padding: "20px" }}>
        <Row>
          <Col span={24}>
            <Space>
              <Image
                // src={`images/photos/${matribenef}.jpg`}
                src={`${api_URL}Participant/getPhoto/${numcont}`}
                alt="Participant"
                style={{
                  width: "120px",
                  height: "160px",
                  objectFit: "cover",
                  borderRadius: "10px",
                  border: "1px solid #ddd",
                  padding: "2px"
                }}
                onError={(e) => {
                  e.target.src = defaultImagePart;
                }}
              />
              <div>
                <h3>
                  <strong>Nom :</strong> {nom}
                </h3>
                <h3>
                  <strong>Prénom :</strong> {prenom}
                </h3>
                <h3>
                  <strong>Matricule :</strong> {matricule}
                </h3>
                <h3>
                  <strong>Date de Naissance :</strong>{" "}
                  {dayjs(datenaiss).format("DD/MM/YYYY")}
                </h3>
              </div>
            </Space>
          </Col>
        </Row>
      </Card>

      <Table
        columns={columns}
        loading={loading}
        dataSource={data}
        scroll={{ x: true }}
        rowKey="matribenef" // Assurez-vous que chaque ligne a une clé unique
        bordered
        // size="small"
        style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
        className="custom-header-table my-custom-table"
        pagination={{ defaultPageSize: 10, showSizeChanger: true }}
      />
    </div>
  );
};

export default Familles;
